<template>
  <div class="app-main-content">
    <div class="details-view">
      <div style="height: 100%">
        <div style="display: flex;flex-wrap: nowrap;height: 100%;">
          <div class="section" style="width: 25%; background-color: #ffffff">
            <div style="">
              <span
                style="position: absolute;top: 6px; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
              >{{ '.' }}</span>
              <div style="padding-left: 10px;padding-bottom: 15px"> {{ $t('CargoMsg.Cargo_TransmissionRule') }}</div>
            </div>
            <div style="height: 50%;">
              <el-form
                label-position="left"
                label-width="0px"
                style="height: 100%"
              >
                <el-form-item label=" " style="height: 100%" class="input-from">
                  <el-input
                    v-model="ruleData"
                    class="input-border"
                    :filter-chars="false"
                    type="textarea"
                    :readonly="true"
                    clearable
                  />
                </el-form-item>
              </el-form>
            </div>
            <div style="display: flex;padding-top: 5px;padding-bottom: 5px;justify-content: space-between;">
              <div style="display: flex; align-items: center;">
                <span
                  style="position: absolute; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
                >{{ '.' }}</span>
                <div style="padding-left: 10px; display: flex;">
                  {{ $t('CargoMsg.Cargo_AccountPassword') }}
                </div>
              </div>
            </div>
            <div style="height: 50%; margin-top: 12px;">
              <el-form
                label-position="left"
                label-width="100px"
                style="height: 100%"
              >
                <el-form-item :label="$t('CargoMsg.Cargo_AccountNumber') + ':'">
                  <el-input v-model="nbParams.accountId" no="accountId" style="width: 300px" />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_Password') + ':'">
                  <el-input v-model="nbParams.passWord" no="passWord" type="password" style="width: 300px" />
                </el-form-item>
                <el-form-item label="id:">
                  <el-input v-model="nbParams.id" no="id" style="width: 300px" />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_GetTokenUrl') + ':'">
                  <el-input v-model="nbParams.tokenUrl" no="url" style="width: 300px" />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_InterfaceUrl') + ':'">
                  <el-input v-model="nbParams.interfaceUrl" no="taskName" style="width: 300px" />
                </el-form-item>
                <el-form-item label="action:">
                  <el-input v-model="nbParams.action" no="action" style="width: 300px" />
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="section" style="width: 35%;background-color: #ffffff">
            <div style="display: flex;justify-content: space-between;">
              <div>
                <span
                  style="position: absolute;top: 6px; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
                >{{ '.' }}</span>
                <div style="padding-left: 10px;padding-bottom: 5px"> {{ $t('CargoMsg.Cargo_Script') }} </div>
              </div>
              <div style="padding: 1px">
                <el-button type="success" @click="deBugHandler">{{ $t('CargoMsg.Cargo_DebuggingResults') }}</el-button>
              </div>
            </div>
            <div style="display: flex;height: 100%;">
              <div style="height: 100%;width: 100%">
                <el-form
                  label-position="left"
                  label-width="0px"
                  style="height: 100%"
                >
                  <el-form-item label=" " style="height: 100%" class="input-from">
                    <el-input
                      v-model="nbParams.dataScript"
                      class="input-border"
                      :filter-chars="false"
                      type="textarea"
                      clearable
                    />
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
          <div class="section" style="width: 40%; background-color: #ffffff">
            <div style="">
              <span
                style="position: absolute;top: 6px; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
              >{{ '.' }}</span>
              <div style="padding-left: 10px;padding-bottom: 15px"> {{ $t('CargoMsg.Cargo_TransmissionSample') }}</div>
            </div>
            <div style="height: 100%;">
              <el-form
                label-position="left"
                label-width="0px"
                style="height: 100%"
              >
                <el-form-item label=" " style="height: 100%" class="input-from">
                  <el-input
                    v-model="dataMessage"
                    :disabled="!isPlatform"
                    class="input-border"
                    :readonly="true"
                    :placeholder="contentTip"
                    :filter-chars="false"
                    type="textarea"
                    clearable
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <show-message-dialog
      v-if="showMessage.visible"
      :visible.sync="showMessage.visible"
      :message-text="showMessage.messageText"
    />
  </div>
</template>

<script>

import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { cache, cacheName } from '@/utils/cacheManager'
import { pushShippingExchangeDeBugFunc } from '@/api/clearing/invoice'
import showMessageDialog from '@/views/cargo/v0/Clearing/components/SharedCenter/showMessageDialog.vue'

export default {
  name: 'SettlementRateSettings',
  components: { showMessageDialog },
  props: {},
  data() {
    return {
      SystemConstants,
      querySql: '',
      showMessage: {
        visible: false,
        messageText: ''
      },
      nbParams: {
        accountId: '',
        passWord: '',
        id: '',
        tokenUrl: '',
        interfaceUrl: '',
        action: '',
        dataScript: ''
      },
      dataMessage: '',
      ruleData: '1.费用状态赋值：\n' +
        '默认实际运费，\n' +
        '1）当有开票日期时，赋值为“开票费用”\n' +
        '2）当有销账日期时，赋值为“销账费用”\n' +
        '2.ATD没有值时取值ETD\n' +
        '3.SOC：当箱型中有一个为SOC时，显示SOC\n' +
        '4.supplierName传输利通\n' +
        '5.费用中的containerSize取业务中的箱型\n' +
        '6.发票是否打印：费用状态=开票费用时，传输Y，其他不传输\n' +
        '7.potName取值卸货港、podName取值交货地\n' +
        '8.accountCancelDate 当费用状态=销账费用时，传输；\n' +
        'invoiceDate、invoiceNo当费用状态=销账费用或者开票费用时，传输；',
      contentTip: '{\n' +
        '\t"ATD": "20250908000000",\n' +
        '\t"ETD": "20250908000000",\n' +
        '\t"billNo": "12345678",\n' +
        '\t"soNo": "111,222,333",\n' +
        '\t"cargoType": "普货",\n' +
        '\t"containerAscription": 1,\n' +
        '\t"containerOwner": "SOC",\n' +
        '\t"containerVolume": "1*40GP,1*40HC,1*40RF",\n' +
        '\t"feeTypeName": [{\n' +
        '\t\t"accountCancelDate": "",\n' +
        '\t\t"baseCurrencyName": "",\n' +
        '\t\t"chargeId": "oR3j56EV7JgsQKEOi_yxRg",\n' +
        '\t\t"containerSize": "40",\n' +
        '\t\t"currencyName": "USD",\n' +
        '\t\t"exchangeRate": 7.9,\n' +
        '\t\t"feeAmount": 622.16,\n' +
        '\t\t"feeCount": 1.121,\n' +
        '\t\t"feeCreateTime": "20250915133109",\n' +
        '\t\t"feeModifyTime": "20250915133300",\n' +
        '\t\t"feeName": "海运费",\n' +
        '\t\t"feeStatus": "1",\n' +
        '\t\t"invoiceDate": "",\n' +
        '\t\t"invoiceNo": "",\n' +
        '\t\t"isPrint": "N",\n' +
        '\t\t"price": 555.0,\n' +
        '\t\t"ratio": 1.0,\n' +
        '\t\t"receivedOrPaid": "应收",\n' +
        '\t\t"remark": ""\n' +
        '\t}, {\n' +
        '\t\t"accountCancelDate": "20250910000000",\n' +
        '\t\t"baseCurrencyName": "",\n' +
        '\t\t"chargeId": "mswcwdBiQoI8RuScFilfQw",\n' +
        '\t\t"containerSize": "40",\n' +
        '\t\t"currencyName": "USD",\n' +
        '\t\t"exchangeRate": 7.9,\n' +
        '\t\t"feeAmount": 124.43,\n' +
        '\t\t"feeCount": 1.121,\n' +
        '\t\t"feeCreateTime": "20250910151226",\n' +
        '\t\t"feeModifyTime": "20250911152052",\n' +
        '\t\t"feeName": "海运费",\n' +
        '\t\t"feeStatus": "3",\n' +
        '\t\t"invoiceDate": "20250304000000",\n' +
        '\t\t"invoiceNo": "TEST001",\n' +
        '\t\t"isPrint": "Y",\n' +
        '\t\t"price": 111.0,\n' +
        '\t\t"ratio": 1.0,\n' +
        '\t\t"receivedOrPaid": "应收",\n' +
        '\t\t"remark": ""\n' +
        '\t}, {\n' +
        '\t\t"accountCancelDate": "",\n' +
        '\t\t"baseCurrencyName": "",\n' +
        '\t\t"chargeId": "hpGq509UnaunSSkiBIV7mw",\n' +
        '\t\t"containerSize": "40",\n' +
        '\t\t"currencyName": "USD",\n' +
        '\t\t"exchangeRate": 7.9,\n' +
        '\t\t"feeAmount": 73.99,\n' +
        '\t\t"feeCount": 1.121,\n' +
        '\t\t"feeCreateTime": "20250915133109",\n' +
        '\t\t"feeModifyTime": "20250915133300",\n' +
        '\t\t"feeName": "海运费",\n' +
        '\t\t"feeStatus": "1",\n' +
        '\t\t"invoiceDate": "",\n' +
        '\t\t"invoiceNo": "",\n' +
        '\t\t"isPrint": "N",\n' +
        '\t\t"price": 66.0,\n' +
        '\t\t"ratio": 1.0,\n' +
        '\t\t"receivedOrPaid": "应收",\n' +
        '\t\t"remark": ""\n' +
        '\t}, {\n' +
        '\t\t"accountCancelDate": "",\n' +
        '\t\t"baseCurrencyName": "",\n' +
        '\t\t"chargeId": "X4cv9imU8Ki7Rwz5k31Kqw",\n' +
        '\t\t"containerSize": "40",\n' +
        '\t\t"currencyName": "USD",\n' +
        '\t\t"exchangeRate": 7.9,\n' +
        '\t\t"feeAmount": 55.0,\n' +
        '\t\t"feeCount": 1.0,\n' +
        '\t\t"feeCreateTime": "20250910151226",\n' +
        '\t\t"feeModifyTime": "20250911151433",\n' +
        '\t\t"feeName": "OF海运费",\n' +
        '\t\t"feeStatus": "2",\n' +
        '\t\t"invoiceDate": "20250304000000",\n' +
        '\t\t"invoiceNo": "TEST001",\n' +
        '\t\t"isPrint": "Y",\n' +
        '\t\t"price": 55.0,\n' +
        '\t\t"ratio": 1.0,\n' +
        '\t\t"receivedOrPaid": "应收",\n' +
        '\t\t"remark": ""\n' +
        '\t}, {\n' +
        '\t\t"accountCancelDate": "",\n' +
        '\t\t"baseCurrencyName": "",\n' +
        '\t\t"chargeId": "Nt8hJxfu-IFRTZx7_HmUCg",\n' +
        '\t\t"containerSize": "40",\n' +
        '\t\t"currencyName": "USD",\n' +
        '\t\t"exchangeRate": 7.9,\n' +
        '\t\t"feeAmount": 871.02,\n' +
        '\t\t"feeCount": 1.121,\n' +
        '\t\t"feeCreateTime": "20250915133109",\n' +
        '\t\t"feeModifyTime": "20250915133300",\n' +
        '\t\t"feeName": "海运费",\n' +
        '\t\t"feeStatus": "1",\n' +
        '\t\t"invoiceDate": "",\n' +
        '\t\t"invoiceNo": "",\n' +
        '\t\t"isPrint": "N",\n' +
        '\t\t"price": 777.0,\n' +
        '\t\t"ratio": 1.0,\n' +
        '\t\t"receivedOrPaid": "应收",\n' +
        '\t\t"remark": ""\n' +
        '\t}],\n' +
        '\t"fullOrLess": "FCL",\n' +
        '\t"jobContainerDesc": "1*40GP;1*40HC;1*40RF",\n' +
        '\t"jobDeliveryPlace": "CAPTC",\n' +
        '\t"jobDischargingPortCode": "CAPTC",\n' +
        '\t"jobLoadingPortCode": "CNNGB",\n' +
        '\t"lineName": "加拿大",\n' +
        '\t"paymentType": "PP",\n' +
        '\t"podName": "CAPTC",\n' +
        '\t"polName": "CNNGb",\n' +
        '\t"potName": "CAPTC",\n' +
        '\t"recordId": "zIcFbtIALoTSTHrq3oG26g",\n' +
        '\t"remark": "",\n' +
        '\t"shipCompanyName": "",\n' +
        '\t"supplierName": "利通",\n' +
        '\t"transportationTerms": "CY-CY",\n' +
        '\t"vesselName": "CSCL NINGBOA",\n' +
        '\t"voyageNo": "v.A186"\n' +
        '}'
    }
  },
  computed: {
    language() {
      return this.$store.getters.language === 'zh'
    },
    isPlatform() {
      return this.$store.getters.isPlatform
    }
  },
  beforeMount() {
  },
  async created() {
    await cache.load(cacheName.CONFIG)
  },
  methods: {
    async onShow(action, from, task) {
      await this.clearParams()
      if (task) {
        if (task.propertiesData && Object.keys(task.propertiesData).length) {
          this.loadProperties(task.propertiesData)
        }
        this.querySql = task.dataScript
      }
    },
    async clearParams() {
      this.nbParams.accountId = ''
      this.nbParams.passWord = ''
      this.nbParams.id = ''
      this.nbParams.tokenUrl = ''
      this.nbParams.interfaceUrl = ''
      this.nbParams.action = ''
      this.nbParams.dataScript = ''
    },
    loadProperties(item) {
      this.nbParams.accountId = item.accountId
      this.nbParams.passWord = item.passWord
      this.nbParams.id = item.id
      this.nbParams.tokenUrl = item.tokenUrl
      this.nbParams.interfaceUrl = item.interfaceUrl
      this.nbParams.action = item.action
      this.nbParams.dataScript = item.dataScript
    },
    deBugHandler() {
      const params = {
        branchId: this.$store.getters.currentOfficeId,
        anyStr: this.querySql,
        anyStr1: this.nbParams.dataScript
      }
      pushShippingExchangeDeBugFunc(params).then(res => {
        this.showMessage.messageText = res.data
        this.showMessage.visible = true
      })
    },
    endTabHandler() {
      this.$emit('ruleSettingChange', { ... this.nbParams })
    },
    toNext() {
      this.$emit('ruleSettingChange', { ... this.nbParams })
    }
  }
}
</script>
<style lang="scss">
.app-main-content {

  .input-from {
    .el-form-item__content {
      width: 100%;
      height: 100%;
    }
  }

  .input-border {
    height: 100%;

    .el-textarea__inner {
      width: 100%;
      height: 100%;
    }
  }

  .general-pagination {
    .el-pager {
      li.number.active {
        color: blue !important;
      }
    }
  }
}
</style>
